<template>
    <div>
      <div class="section-right-content-box">
        <div class="guide">
          <img src="@/assets/images/guide.png" alt  />
        </div>
        <div class="button_guide" >
          <img src="@/assets/images/button_guide.png" alt @click="buttonGuide" style="cursor: pointer;"/>
        </div>
        <div class="text_guide">
           联系客服了解更多云舟亮点
        </div>
      </div>
    
    </div>
  </template>
  
  <script>
  export default {
    methods: {
      buttonGuide(){
        window.open('https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=searchbutton', "_blank");
      }
  }};
  </script>
  <style lang="scss" scoped>
  .section-right-content-box {
    min-width: 1046px;
    background-color: #fff;
    -webkit-border-radius: 6px;
    -moz-border-radius: 6px;
    border-radius: 6px;
    padding: 15px 28px 30px 28px;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    opacity: 1;
    margin: 20px;
    .guide{
       text-align: center;
       display: flex;
       justify-content: center;
       margin-bottom: 30px;
       margin-top: 20px;
    }
    .button_guide{
      text-align: center;
      margin-bottom: 16px;
    }
    .text_guide{
      text-align: center;
      margin-bottom: 15px;
      font-weight: 400;
      font-size: 16px;
      color: #333333;
    }
  }
  </style>